<template>
    <div>
        <div class="top-img">
            <img src="../../static/images/u220.png" alt="">
        </div>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item> <a href="/">{{ $t('lang.index1') }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item>{{ $t('lang.Company') }}</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div MT30" style="height: 680px">
            <div class="MT30">
                <div class="FL MT30">
                    <navComponent/>
                </div>
                <div class="FR" style="width: 1080px;">
                    <div class="int-title margin-auto font-weight text-align">{{ $t('lang.Company') }}</div>
                    <div class="margin-auto font-weight text-align int-title2">{{ $t('lang.Foot') }}</div>
                    <div class="text MT30">
                        <p>
                            <span style="margin-left: 40px"></span>{{ $t('lang.Introduction1') }}
                        </p>
                        <div class="FL" style="width: 788px">
                            <p><span style="margin-left: 40px"></span>
                                {{ $t('lang.Introduction2') }}
                            </p>
                        </div>
                        <div class="FR">
                            <img v-if="locale==='zh'" src="../../static/images/u253.jpg">
                            <img v-if="locale==='en'" src="../../static/images/n253.png">
                        </div>
                        <div class="ClearFloat"></div>
                        <p><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction3') }}
                        </p>
                        <p><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction4') }}
                        </p>
                        <p><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction5') }}
                        </p>
                    </div>
                </div>
                <div class="ClearFloat"></div>
            </div>
        </div>
        <div class="main-div MT30">
            <div class="top-img text-align">
                <img v-if="locale==='zh'" src="../../static/images/u99.png" alt="" style="width:50%">
                <img v-if="locale==='en'" src="../../static/images/e99.png" alt="" style="width:45%">
            </div>
            <!--            <a-row class="MT30" type="flex" justify="space-around">-->
            <!--                <a-col :span="4">-->
            <!--                    <img src="../../static/images/u225.jpg" alt="" class="img-size">-->
            <!--                </a-col>-->
            <!--                <a-col :span="4">-->
            <!--                    <img src="../../static/images/u226.jpg" alt="" class="img-size">-->
            <!--                </a-col>-->
            <!--                <a-col :span="4">-->
            <!--                    <img src="../../static/images/u227.jpg" alt="" class="img-size">-->
            <!--                </a-col>-->
            <!--                <a-col :span="4">-->
            <!--                    <img src="../../static/images/u228.jpg" alt="" class="img-size">-->
            <!--                </a-col>-->
            <!--            </a-row>-->
        </div>
        <div class="main-title text-align font-weight">
            {{ $t('lang.Mission') }}
        </div>
        <div class="main-div">
            <a-row>
                <a-col :span="10">
                    <div class="text" style="margin-top: 40px; color: #666">
                        <p><span class="color1">{{ $t('lang.Mission1') }}</span>：{{ $t('lang.Mission2') }}</p>
                        <p><span class="color1">{{ $t('lang.Mission3') }}</span>：{{ $t('lang.Mission4') }}</p>
                        <p><span class="color1">{{ $t('lang.Mission5') }}</span>：{{ $t('lang.Mission6') }}</p>
                        <p><span class="color1">{{ $t('lang.Mission7') }}</span>：{{ $t('lang.Mission8') }}</p>
                        <p><span class="color1">{{ $t('lang.Mission9') }}</span>：{{ $t('lang.Mission10') }}</p>
                    </div>
                </a-col>
                <a-col :span="3"></a-col>
                <a-col :span="11">
                    <img src="../../static/images/u231.jpg" alt="" style="width: 585px;height: 329px;margin-left: 40px">
                </a-col>
            </a-row>
        </div>
        <!--        <div class="main-title text-align font-weight">-->
        <!--            公司组织架构-->
        <!--        </div>-->
        <!--        <div class="main-div">-->
        <!--            <div class="top-img text-align">-->
        <!--                <img src="../../static/images/u99.jpg" alt="" style="width:50%">-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import navComponent from "@/components/navcomponents";

export default {
    name: "Introduction",
    components: {
        navComponent
    },
    data() {
        return {
            locale: 'zh',
        }
    },
    mounted() {
        document.title = '贝威科技(潍坊)有限公司-公司简介'
        this.locale = localStorage.getItem("lang") || 'zh';
        const box = document.getElementsByTagName('html');
        box[0].scrollTop = 0;
    },
}
</script>

<style scoped>
.int-title {
    font-size: 28px;
    width: 180px;
    color: #3a8ee6;
    border-bottom: 1px solid #3a8ee6;
}

.int-title2 {
    margin-top: 8px;
    font-size: 18px;
}

.main-title {
    width: 100%;
    height: 100px;
    font-size: 28px;
    color: white;
    background: #4FA0A0;
    line-height: 100px;
    margin: 20px 0;
}

.img-size {
    width: 300px;
    height: 200px
}

.top-img {
    width: 100%;
}

.top-img img {
    width: 100%;
}

.color1 {
    color: #004da0;
    font-weight: bold;
}
</style>
